export const STROKE_WIDTH = 2;
export const STROKE_OPACITY = 1;
export const FILL_OPACITY = 0.1;

export const AXIS_RIGHT_WIDTH = 100;
export const AXIS_BOTTOM_HEIGHT = 21;

export const CHART_MARGIN = { bottom: AXIS_BOTTOM_HEIGHT, left: 0, right: 0, top: 0 };
export const CHART_PADDING = { bottom: 0, left: 0, right: AXIS_RIGHT_WIDTH, top: 20 };
